/* eslint-disable max-len */
import React from 'react';

export const ConfirmedCheck = ({
  size = 16,
}: {
  size?: number;
}): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M8 0.5C9.0572 0.5 9.9915 1.02554 10.5566 1.82812C11.5241 1.66011 12.5555 1.95 13.3027 2.69727C14.0495 3.44403 14.3384 4.47659 14.1709 5.44238C14.9741 6.00744 15.5 6.94232 15.5 8C15.5 9.05748 14.9738 9.99155 14.1709 10.5566C14.339 11.5242 14.05 12.5554 13.3027 13.3027C12.5557 14.0497 11.5227 14.3387 10.5566 14.1709C9.99155 14.9738 9.05748 15.5 8 15.5C6.94232 15.5 6.00744 14.9741 5.44238 14.1709C4.47514 14.3386 3.44433 14.0498 2.69727 13.3027C1.9503 12.5558 1.66036 11.5227 1.82812 10.5566C1.02554 9.9915 0.5 9.0572 0.5 8C0.5 6.9426 1.02528 6.00749 1.82812 5.44238C1.66047 4.47519 1.95025 3.44429 2.69727 2.69727C3.44399 1.95054 4.47664 1.66071 5.44238 1.82812C6.00749 1.02528 6.9426 0.5 8 0.5ZM10.7383 6.14355C10.6726 6.07858 10.5738 6.08391 10.5186 6.13965L7.12793 9.53027L5.48926 7.8916C5.4265 7.82884 5.32908 7.83161 5.27148 7.88965C5.22284 7.93882 5.21351 8.0064 5.23535 8.06055L5.26758 8.10938L7.01953 9.86133C7.08236 9.92395 7.17979 9.92141 7.2373 9.86328L7.23926 9.86133L10.7363 6.36133L10.7715 6.30859C10.7943 6.25208 10.7817 6.18667 10.7383 6.14355Z"
      fill="#376913"
      stroke="white"
    />
  </svg>
);
